export default "__VITE_ASSET__jN9NEM5v__"